<template>
  <div class="complexes">
    <div class="complexes__header header">
      <div class="header__item header__item--system">Система</div>
      <div class="header__item header__item--complex-name">Название комплекса</div>
      <div class="header__item header__item--date">Дата обновления</div>
      <div class="header__item header__item--specialist-name">Специалист</div>
    </div>
    <template v-loading="loading">
      <complex-list-item v-for="(complex, index) in complexList"
                         :key="complex.id"
                         :index="index"
                         :complex="complex"
                         @delete="deleteItem"/>
      <el-alert
          v-if="complexList && complexList.length === 0"
          :closable="false"
          class="noty-alert"
          title="Нет данных о комплексах"
          type="warning"
          style="margin-top: 5px;"
      />
    </template>
  </div>
</template>

<script>
import {mapActions} from "vuex"
import ComplexListItem from "@/components/complexExercises/ComplexListItem"

export default {
  name: "ComplexList",
  props: {
    complexList: {
      type: Array,
      default: () => ([])
    },
    loading: {
      type: Boolean,
      default: false
    },
  },
  components: {
    ComplexListItem
  },
  methods: {
    ...mapActions({
      deleteComplex: "complexExercises/deleteComplex"
    }),
    deleteItem(id) {
      this.deleteComplex(id)
      this.$emit('update')
    }
  }
}
</script>

<style scoped lang="scss">
.complexes {
  width: 100%;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;

  box-sizing: border-box;

  &__item {
    margin-right: 16px;

    font-weight: 500;
    font-size: 13px;
    line-height: 16px;
    letter-spacing: -0.005em;
    color: #8E8E93;

    @media (max-width: 1199px) {
      margin-right: 24px;
    }

    &--system {
      width: 183px;

      @media (max-width: 1199px) {
        width: 15%;
      }
    }

    &--complex-name {
      width: 513px;

      @media (max-width: 1199px) {
        width: 27%
      }
    }

    &--date {
      width: 159px;

      @media (max-width: 1199px) {
        width: 25%;
      }
    }

    &--specialist-name {
      width: 159px;

      @media (max-width: 1199px) {
        width: 17%
      }
    }
  }
}

/deep/ .el-loading-mask {
  background-color: rgba(239, 239, 244, .87) !important;
}
</style>
